import React from 'react';
import styled from 'styled-components';

import { Menu } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';

import { activeMenuColor, blue, fontColor, grayBorder } from './Colors';
import * as CatSizes from './sizes';
import SubMenu from './SubMenu';

export interface IMenuItem {
  label?: string;
  id: string;
  children?: Array<IMenuItem>;
}

const StyledButton = withStyles({
  root: {
    color: `${fontColor}`,
    fontSize: '12px',
  },
})(Button);

const StyledMenu = withStyles({
  paper: {
    background: `${blue}`,
    color: `${fontColor}`,
    fontSize: `12px`,
  },
  list: {
    '&> li': {
      fontSize: '16px',
      paddingRight: '0px',
      paddingLeft: '0px',
      '&:hover': {
        background: `${activeMenuColor}`,
      },
    },
  },
})(Menu);

const Container = styled.div`
  ${grayBorder};
  display: grid;
  grid-template-columns: ${CatSizes.MenuBarArea.width}px ${CatSizes
      .HookTrackArea.width}px;
  height: ${CatSizes.MenuBarArea.height}px;
`;

export default function CatizMenu({
  menuItems = [],
}: {
  menuItems: Array<any>;
}) {
  const [open, setOpen] = React.useState(false);
  const [anchorEle, setAnchorEle] = React.useState<any>(null);
  const [subMenuItems, setSubMenuItems] = React.useState<Array<any>>([]);

  const handleToggle = (menuItem) => {
    setAnchorEle(menuItem);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    setOpen(false);
  };

  return (
    <Container>
      <div>
        {menuItems.map((menuItem) => {
          return (
            <StyledButton
              id={menuItem.id}
              key={menuItem.label}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={(evt) => {
                handleToggle(evt.target as any);
                setSubMenuItems(menuItem.children || []);
              }}
            >
              {menuItem.label}
            </StyledButton>
          );
        })}
        <StyledMenu
          id="simple-menu"
          anchorEl={() => anchorEle}
          getContentAnchorEl={null}
          keepMounted
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          {subMenuItems.map((subMenuItem) => {
            return (
              <MenuItem key={subMenuItem.label}>
                <SubMenu
                  menuItem={subMenuItem}
                  closeParent={() => setOpen(false)}
                />
              </MenuItem>
            );
          })}
        </StyledMenu>
      </div>
      <div>
        <SearchIcon />
      </div>
    </Container>
  );
}
